import React, { Component } from 'react';

export default class IntToDateInputElement extends Component {
  static defaultProps = {
    value: 0,
    onChange: () => {},
  };

  state = {
    time: {
      days: 0,
      hours: 0,
      minutes: 0,
    },
  };

  componentDidMount() {
    let time = this.getValue();
    this.setState({ time });
  }

  getValue() {
    let seconds = this.props.value * 60;

    let day = Math.floor(seconds / (3600 * 24));
    let hour = Math.floor((seconds % (3600 * 24)) / 3600);
    let minute = Math.floor((seconds % 3600) / 60);
    let second = Math.floor(seconds % 60);

    return {
      days: day,
      hours: hour,
      minutes: minute,
      second: second,
    };
  }

  onChange(result, field) {
    let timeTemp = this.state.time;
    timeTemp[field] = result;
    let time = timeTemp.days * 60 * 24 + timeTemp.hours * 60 + timeTemp.minutes * 1;
    this.props.onChange(time);
  }

  render() {
    return (
      <div className='w-100 input-group mb-3'>
        <input
          type='number'
          className='form-control'
          min='0'
          onChange={(e) => {
            try {
              let input = parseInt(e.target.value);

              if (input < 0) input = input * -1;

              this.onChange(input, 'days');
            } catch {}
          }}
          value={this.state.time.days}
        />
        <span className='input-group-text'>days</span>
        <input
          type='number'
          className='form-control'
          pattern='\d+'
          min='0'
          value={this.state.time.hours}
          onChange={(e) => {
            try {
              let input = parseInt(e.target.value);

              if (input < 0) input = input * -1;

              this.onChange(input, 'hours');
            } catch {}
          }}
        />
        <span className='input-group-text'>hours</span>
        <input
          type='number'
          className='form-control'
          min='0'
          value={this.state.time.minutes}
          onChange={(e) => {
            try {
              let input = parseInt(e.target.value);

              if (input < 0) input = input * -1;

              this.onChange(input, 'minutes');
            } catch {}
          }}
        />
        <span className='input-group-text'>minutes</span>
      </div>
    );
  }
}
